import { cn } from '@/lib/utils';
import { INVOICE_HOME_TOUR } from '../tours/invoiceTours';
import { AssistantIcon } from './AssistantIcon';
import { BetaBadge } from './AssistantPanel';
import { useInvoiceAssistant } from './useInvoiceAssistant';

/** Abre y cierra el asistente desde la barra de arriba. Sin bandera no se pinta. */
export const AssistantLauncher = () => {
  const assistant = useInvoiceAssistant();
  if (!assistant) return null;

  return (
    <button
      {...INVOICE_HOME_TOUR.anchor('invoice-assistant')}
      type='button'
      aria-pressed={assistant.isOpen}
      onClick={assistant.toggle}
      className={cn(
        'flex min-h-9 flex-none items-center gap-1.5 rounded-full border px-3 text-[13px] font-medium transition-colors duration-150 active:scale-[0.96]',
        assistant.isOpen
          ? 'border-h-primary-50 bg-h-primary-95 text-h-primary-30'
          : 'border-h-neutral-90 text-h-text-heading bg-white',
      )}>
      <AssistantIcon size={18} animated={false} />
      <span className='hidden sm:inline'>Asistente</span>
      <BetaBadge />
    </button>
  );
};
